import { render, staticRenderFns } from "./VectorMapsHeader.vue?vue&type=template&id=139ae158&"
import script from "./VectorMapsHeader.vue?vue&type=script&lang=js&"
export * from "./VectorMapsHeader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports